import { LocationMarker } from "@repo/icons";
import { CpsBadge } from "corpus";

interface CommunityCardUserLocationsProps {
  locations: string[];
}

export const CommunityCardUserLocations = ({
  locations,
}: CommunityCardUserLocationsProps): JSX.Element => {
  const displayedUnits = locations.filter((x) => Boolean(x)).slice(0, 2);
  const remainingUnitsCount = locations.length - displayedUnits.length;

  return (
    <div className="flex flex-row gap-1 items-center mt-1">
      <LocationMarker size={24} className="fill-primary-500" />
      <p>
        <div className="flex flex-row gap-1">
          {displayedUnits.join(", ")}
          {remainingUnitsCount > 0 && (
            <CpsBadge color="neutral">+{remainingUnitsCount}</CpsBadge>
          )}
        </div>
      </p>
    </div>
  );
};
